/**
 * Partner monthly report download UI.
 * Set REACT_APP_SERVICE_VENDOR_REPORT=false to hide Download partner report.
 * Unset or true → enabled (backend export API expected).
 */
export const isServiceVendorReportEnabled = () => {
  const raw = String(process.env.REACT_APP_SERVICE_VENDOR_REPORT ?? '')
    .trim()
    .toLowerCase();
  if (raw === 'false' || raw === '0' || raw === 'no' || raw === 'off') {
    return false;
  }
  return true;
};
